import { render, staticRenderFns } from "./recordList.vue?vue&type=template&id=2eb69e83&scoped=true&"
import script from "./recordList.vue?vue&type=script&lang=js&"
export * from "./recordList.vue?vue&type=script&lang=js&"
import style0 from "./recordList.vue?vue&type=style&index=0&id=2eb69e83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb69e83",
  null
  
)

export default component.exports